import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Teleport as _Teleport, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/logo-lion-parcel-red.svg'
import _imports_1 from '@/app/ui/assets/svg/cod-logo-3.svg'
import _imports_2 from '@/app/ui/assets/svg/new-dfod-2.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-10289ada")

_pushScopeId("data-v-10289ada")
const _hoisted_1 = {
  key: 0,
  id: "invoice-pdf-struk",
  class: "p-3 invoice-pdf-struk absolute",
  style: {"max-width":"360px","left":"-9999999px","min-height":"360px"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "w-full flex flex-row items-center justify-center" }, [
  /*#__PURE__*/_createVNode("img", { src: _imports_0 })
], -1)
const _hoisted_3 = { class: "flex flex-col gap-1 py-3" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "flex flex-row items-baseline py-2 border-t border-b border-dashed border-gray-lp-400" }
const _hoisted_7 = {
  style: {"min-width":"169.5px"},
  class: "pr-4"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "pr-0.5" }, ":", -1)
const _hoisted_9 = { class: "py-3" }
const _hoisted_10 = { class: "table-invoice" }
const _hoisted_11 = { style: {"min-width":"175px"} }
const _hoisted_12 = { class: "flex flex-row gap-2 items-center" }
const _hoisted_13 = {
  key: 0,
  style: {"height":"9px"},
  src: _imports_1,
  alt: "cod"
}
const _hoisted_14 = {
  key: 1,
  style: {"height":"10px"},
  src: _imports_2,
  alt: "cod"
}
const _hoisted_15 = { style: {"min-width":"80px"} }
const _hoisted_16 = { class: "flex flex-col" }
const _hoisted_17 = { style: {"min-width":"80px"} }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { class: "flex flex-col gap-1 items-baseline py-2 border-t border-b border-dashed border-gray-lp-400" }
const _hoisted_22 = { class: "flex flex-row" }
const _hoisted_23 = {
  style: {"min-width":"169.5px"},
  class: "pr-4"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "pr-0.5" }, ":", -1)
const _hoisted_25 = { class: "flex flex-row" }
const _hoisted_26 = {
  style: {"min-width":"169.5px"},
  class: "pr-4"
}
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "pr-0.5" }, ":", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.show)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _hoisted_2,
          _createVNode("div", _hoisted_3, [
            _createVNode("p", _hoisted_4, _toDisplayString(_ctx.invoiceData.referenceName), 1),
            _createVNode("p", _hoisted_5, _toDisplayString(_ctx.formatDateWithTz(_ctx.invoiceData.createdAt, "DD MMM YYYY, HH:mm")), 1)
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("tagihan.pdf.billedTo")), 1),
            _hoisted_8,
            _createVNode("div", null, _toDisplayString(_ctx.invoiceData.billedToName) + " (" + _toDisplayString(_ctx.maskSensitiveData(_ctx.invoiceData.billedToPhone)) + ")", 1)
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("table", _hoisted_10, [
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                  return (_openBlock(), _createBlock("tr", {
                    key: item.sttNo
                  }, [
                    _createVNode("td", _hoisted_11, [
                      _createVNode("div", _hoisted_12, [
                        _createTextVNode(_toDisplayString(item.sttNo) + " ", 1),
                        (item.isCod && !item.isDfod)
                          ? (_openBlock(), _createBlock("img", _hoisted_13))
                          : _createCommentVNode("", true),
                        (item.isCod && item.isDfod)
                          ? (_openBlock(), _createBlock("img", _hoisted_14))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createVNode("td", _hoisted_15, [
                      _createVNode("div", _hoisted_16, [
                        _createVNode("div", null, _toDisplayString(item.productType), 1),
                        _createTextVNode(" " + _toDisplayString(item.chargeableWeight) + " kg ", 1)
                      ])
                    ]),
                    _createVNode("td", _hoisted_17, [
                      (item.paymentLabel === 'paid_by_recipient')
                        ? (_openBlock(), _createBlock("span", _hoisted_18, _toDisplayString(_ctx.$t("tagihan.table.paidByRecipient")), 1))
                        : (item.paymentLabel === 'paid_via_app')
                          ? (_openBlock(), _createBlock("span", _hoisted_19, _toDisplayString(_ctx.$t("tagihan.table.paidViaApp")), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_20, _toDisplayString(_ctx.formatPriceAmount(item.amount)), 1))
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createVNode("div", _hoisted_21, [
            _createVNode("div", _hoisted_22, [
              _createVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("tagihan.form.totalStt")), 1),
              _hoisted_24,
              _createVNode("div", null, _toDisplayString(_ctx.invoiceData.totalStt) + " STT", 1)
            ]),
            _createVNode("div", _hoisted_25, [
              _createVNode("div", _hoisted_26, _toDisplayString(_ctx.$t("tagihan.modal.totalAmount")), 1),
              _hoisted_27,
              _createVNode("div", null, _toDisplayString(_ctx.formatPriceAmount(_ctx.invoiceData.totalAmount)), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})